import { render, staticRenderFns } from "./Approval-View.vue?vue&type=template&id=5b288f59&scoped=true&"
import script from "./Approval-View.vue?vue&type=script&lang=js&"
export * from "./Approval-View.vue?vue&type=script&lang=js&"
import style0 from "./Approval-View.vue?vue&type=style&index=0&id=5b288f59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b288f59",
  null
  
)

export default component.exports